import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TemplateModule } from 'src/app/template/template.module';

import { ApprobationsEditionComponent } from './components/approbations-edition/approbations-edition.component';

import { ApprobationService } from './services/approbation.service';

@NgModule({

    declarations: [
        ApprobationsEditionComponent
    ],

    imports: [
        CommonModule,
        SharedModule,
        TemplateModule
    ],

    providers: [
        ApprobationService
    ],

    exports: [
        ApprobationsEditionComponent
    ]

})
export class ApprobationsModule { }
